<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <div class="box">
                    <div class="box-body">
                        <v-server-table url="" :columns="columns" :options="options" name="places" ref="places"
                                        @loading="toggleLoading" @loaded="toggleLoading" @row-click="showPlace">
                            <template slot="actions" slot-scope="props">
                                <div>
                                    <button class="btn btn-danger btn-sm" v-on:click.stop="remove(props.row.id)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </template>
                        </v-server-table>
                    </div>
                    <!-- /.box-body -->
                    <div class="overlay" v-show="loading">
                        <i class="fa fa-refresh fa-spin"></i>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import placesApi from '../../api/places'

  export default {
    data () {
      return {
        columns: [
          'nome', 'indirizzo', 'actions'
        ],
        options: {
          sortable: [
            'nome', 'indirizzo'
          ],
          requestFunction: function (query) {
            return placesApi.index(query)
          }
        },
        loading: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Luoghi inseriti',
        createButton: {
          display: true,
          text: 'Nuovo luogo',
          to: 'place'
        }
      })
    },

    methods: {
      remove (id) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          placesApi.delete(id)
            .then((response) => {
              this.$refs.places.refresh()
              toastr.success('Il luogo è stato rimosso correttamente')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      toggleLoading () {
        // this.loading = !this.loading
      },
      showPlace (row) {
        this.$router.push({name: 'placesShow', params: {id: row.row.id}})
      }
    }
  }
</script>

<style>
    tr {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/places/Index.vue